import React from 'react';

import { ContextGlobal as CG } from 'contexts';
import { RouterHistoryProvider as RHP } from 'providers';

// eslint-disable-next-line import/no-cycle
import { routes } from '../RankingRoutes';
import { RankingIndexView } from './RankingIndexView';

export const RankingIndex = props => {
    const { emitAlert } = React.useContext(CG);
    // Route to return after validations
    const { setReturnTo } = props.useRanking;

    // Paths that are not avaliable yet;
    const closedPaths = [];

    // Add the path to the return path
    const handleClick = path => {
        if (closedPaths.includes(path)) {
            emitAlert(props.t('notAvaliable'));
            return false;
        }
        setReturnTo(path);
        return RHP.push('/ranking/term');
    };

    // Create the secondary actions options
    const actions = routes
        .filter(r => r.name)
        .map(r => ({
            disabled: closedPaths.includes(r.path),
            icon: r.icon,
            text: props.t(`menu.${r.name}`),
            onClick: () => handleClick(r.path),
        }));

    const propsView = { ...props, actions };
    return <RankingIndexView {...propsView} />;
};
export default RankingIndex;
